import { Book, Calendar, Trophy, Users } from "lucide-react";
import React from "react";
import AchievementReusableComponent from "../../utilitis/AchievementReusable";

const StudentWeeks = () => {
  const achievementData = {
    title: "Student Weeks",
    subtitle: "Celebrating Student Life and Achievement",
    description:
      "Engaging activities fostering student involvement and celebrating students achievements.",
    images: [
      "https://i.ibb.co/php9mqB/SW-18.jpg",
      "https://i.ibb.co/LhKt1QP/SW-06.jpg",
      "https://i.ibb.co/58GdKzx/SW-09.jpg",
      "https://i.ibb.co/KhbSYwY/SW-05.jpg",
      "https://i.ibb.co/jLv1WYm/depity-with-dawda.jpg",
      "https://i.ibb.co/4gHf49b/SW-03.jpg",
      "https://i.ibb.co/d6Bp46C/student-week-group.jpg",
      "https://i.ibb.co/wzsrhdk/Gam-ind-grad-with-fift-presiden.jpg"
    ],
    iconTexts: [
      { icon: Calendar, text: "Annual Event" },
      { icon: Users, text: "100+ Participants" },
      { icon: Book, text: "Multiple Activities" },
      { icon: Trophy, text: "Awards Ceremony" },
    ],
    highlights: [
      "Academic achievement celebration across various disciplines",
      "Cultural performances showcasing student talents",
      "Panel discussion on matters affecting Gambia",
      "Strengthen bilateral with indian Universities",
      "Sports tournaments promoting healthy competition",
    ],
    upcomingEvents: [
      {
        title: "Inter-State Debate Championship",
        description:
          "Platform where Gambian students debate across different state in India  ",
        date: "October 11, 2024",
      },
      {
        title: "Online Game",
        description:
          "Remote online games to be play with different Gam-Ind students",
        date: "October 12, 2024",
      },
      {
        title: "Gambia's 60th Independence Celebration",
        description:
          "Bringing all Gambian across India to celebrate Gambia's independence",
        date: "February 18, 2025",
      },
    ],
    galleryLink: "/gallery",
  };

  return <AchievementReusableComponent {...achievementData} />;
};

export default StudentWeeks;
